import { Card, CardBody, Col, Input, InputGroup } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { AddonPlaceHolder, ButtonAddon, SubmitButtonAddon, SubmitButtonAddonPlaceHolder } from "../../../../Constant";
import { BUTTON_ADDON } from "../../../../Data/FormControl/InputGroups";

const ButtonAddons = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={ButtonAddon} span={BUTTON_ADDON}/>
        <CardBody className="card-wrapper input-group-wrapper">
          <InputGroup>
            <Btn color='secondary' outline id="button-addon1">{'$ 25'}</Btn>
            <Input type="text" id="button-addon1"/>
          </InputGroup>
          <InputGroup>
            <Input type="text" placeholder={SubmitButtonAddonPlaceHolder} id="button-addon2"/>
            <Btn color='warning' outline id="button-addon2">{SubmitButtonAddon}</Btn>
          </InputGroup>
          <InputGroup>
            <Btn color='secondary'><span>&#8364; </span></Btn>
            <Btn color='warning'>{'0.0114419'}</Btn>
            <Input type="text"/>
          </InputGroup>
          <InputGroup>
            <Input type="text" placeholder={AddonPlaceHolder}/>
            <Btn color='secondary'><span>&#8377;</span></Btn>
            <Btn color='warning'>{'500'}</Btn>  
          </InputGroup>
        </CardBody>
      </Card>
    </Col>
  )
};

export default ButtonAddons;
